export const actions = {
  MAIL_TEMPLATE_BY_ID_LOAD_REQUESTED: 'MAIL_TEMPLATE_BY_ID_LOAD_REQUESTED',
  MAIL_TEMPLATE_BY_ID_LOAD_SUCCEEDED: 'MAIL_TEMPLATE_BY_ID_LOAD_SUCCEEDED',
  MAIL_TEMPLATE_BY_ID_LOAD_FILED: 'MAIL_TEMPLATE_BY_ID_LOAD_FILED',

  MAIL_TEMPLATE_LIST_LOAD_REQUESTED: 'MAIL_TEMPLATE_LIST_LOAD_REQUESTED',
  MAIL_TEMPLATE_LIST_LOAD_SUCCEEDED: 'MAIL_TEMPLATE_LIST_LOAD_SUCCEEDED',
  MAIL_TEMPLATE_LIST_LOAD_FAILED: 'MAIL_TEMPLATE_LIST_LOAD_FAILED',

  MAIL_TEMPLATE_INSERT_REQUESTED: 'MAIL_TEMPLATE_INSERT_REQUESTED',
  MAIL_TEMPLATE_INSERT_SUCCEEDED: 'MAIL_TEMPLATE_INSERT_SUCCEEDED',
  MAIL_TEMPLATE_INSERT_FAILED: 'MAIL_TEMPLATE_INSERT_FAILED',

  MAIL_TEMPLATE_UPDATE_REQUESTED: 'MAIL_TEMPLATE_UPDATE_REQUESTED',
  MAIL_TEMPLATE_UPDATE_SUCCEEDED: 'MAIL_TEMPLATE_UPDATE_SUCCEEDED',
  MAIL_TEMPLATE_UPDATE_FILED: 'MAIL_TEMPLATE_UPDATE_FILED',
}

export const getMailTemplateList = dispatch => {
  dispatch({
    type: actions.MAIL_TEMPLATE_LIST_LOAD_REQUESTED,
  })
}

export const onSubmitUpdateMailTemplateFormAction = (dispatch, mailTemplateForm) => {
  dispatch({
    type: actions.MAIL_TEMPLATE_UPDATE_REQUESTED,
    payload: mailTemplateForm,
  })
}

export const onSubmitInsertMailTemplateFormAction = (dispatch, mailTemplateForm) => {
  dispatch({
    type: actions.MAIL_TEMPLATE_INSERT_REQUESTED,
    payload: mailTemplateForm,
  })
}

export const getMailTemplateByPaginaOkTemplateId = (dispatch, mailTemplateId) => {
  dispatch({
    type: actions.MAIL_TEMPLATE_BY_ID_LOAD_REQUESTED,
    payload: mailTemplateId,
  })
}
